import './floatingactionbutton.css';
import { FloatingActionButton as KendoFloatingActionButton } from "@progress/kendo-react-buttons";
import { Avatar } from "@progress/kendo-react-layout";
import { SvgIcon } from "@progress/kendo-react-common";
import { isArrayEmpty } from '../helpers/ObjectHelpers';
import { useRef } from 'react';
import { getElementsByClassName } from '../helpers/ElementHelpers';
import { useTextLineBreak } from '../hooks/useTextLineBreak';

export default function FloatingActionButton(
    {
        themeColor = "",
        svgIcon,
        onClick,
        onItemClick,
        disabled = false,
        items = []
    }
) {

    const buttonRef = useRef(null);

    const onOpen = () => {
        setTimeout(() => {
            const animationElems = getElementsByClassName("k-animation-container");
            const drawerElems = getElementsByClassName("k-drawer-container");

            if (isArrayEmpty(animationElems) || isArrayEmpty(drawerElems)) return;

            const drawerElem = drawerElems[0];
            let right = 10;

            if (drawerElem.classList.contains("k-drawer-push")) {
                const isExpanded = drawerElem.classList.contains("k-drawer-expanded");
                const isMini = drawerElem.classList.contains("k-drawer-mini");

                if (isExpanded) {
                    right = right + 240;
                }
                if (isMini) {
                    right = right + 48;
                }
            }

            const animationElem = animationElems[0];
            animationElem.style.left = "unset";
            animationElem.style.right = `${right}px`;
        }, 50);
    }

    return (
        (isArrayEmpty(items)) ?
            <KendoFloatingActionButton
                id="FloatingButton"
                ref={buttonRef}
                themeColor={themeColor}
                svgIcon={svgIcon}
                onClick={onClick}
                disabled={disabled}
            />
            :
            <KendoFloatingActionButton
                id="FloatingButton"
                ref={buttonRef}
                themeColor="primary"
                svgIcon={svgIcon}
                onItemClick={handleOnItemClick}
                item={FloatingActionButtonItem}
                popupSettings={{
                    popupClass: "floating-action-button-items"
                }}
                items={items}
                onOpen={onOpen}
            />
    );

    function handleOnItemClick(e) {
        const obj = e.itemProps;
        obj.source = e.itemProps;
        onItemClick(obj);
    }
}

const FloatingActionButtonItem = (props) => {
    const { textRef, textLines } = useTextLineBreak(props.item.text, '50vw');

    return (
        <div className="floating-action-button-item-container">
            <div className="floating-action-button-item-text-container">
                <div ref={textRef}>
                    {textLines.map((line, index) => (
                        <div key={index}>{line}</div>
                    ))}
                </div>
                {
                    props.item.subtext &&
                    <div className="floating-action-button-item-sub-text">
                        {props.item.subtext}
                    </div>
                }
            </div>
            <div>
                <Avatar type="icon" size="large" themeColor="secondary">
                    <SvgIcon icon={props.item.svgIcon} size="xlarge" />
                </Avatar>
            </div>
        </div>
    );
}
